import { Link, useLocation } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** 
 * Sticky "Book a Viewing" CTA that floats above the mobile bottom nav.
 * Only visible on mobile, hidden on pages where it's redundant (viewing-plan, property detail, auth).
 */
export function StickyMobileCTA() {
  const { pathname } = useLocation();

  // Hide on pages where it's redundant
  const hiddenPaths = ['/viewing-plan', '/auth', '/property'];
  const shouldHide = hiddenPaths.some(p => pathname.startsWith(p));
  if (shouldHide) return null;

  return (
    <div className="fixed bottom-16 left-0 right-0 z-40 md:hidden px-4 pb-2 safe-area-bottom pointer-events-none">
      <Link to="/viewing-plan" className="pointer-events-auto block">
        <Button 
          size="lg" 
          className="w-full gap-2 h-12 shadow-lg text-sm font-semibold"
        >
          <CalendarCheck className="w-5 h-5" />
          Book a Viewing — It's Free
        </Button>
      </Link>
    </div>
  );
}
